import Hero from "../components/Hero";
import UpcommingEvents from "../components/events/UpcomingEvents";
import Reviews from "../components/reviews/Reviews";
import Welcome from "../components/Welcome";
import AnimatedRentalSection from "../components/AnimatedRentalSection";
import WeeklySaturdayMarket from "../components/WeeklySaturdayMarket";
import FindUs from "../components/FindUs";
import EventAlertPopup from "../components/EventAlertPopup";

const TICKER_ITEMS = [
  "🥕 Fresh Produce",
  "🎨 Artisan Goods",
  "🍞 Local Bakers",
  "🌸 Community Events",
  "🎵 Live Music",
  "🧺 100+ Vendors",
  "📍 St. John's, NL",
  "☀️ Rain or Shine",
  "🤝 Support Local",
  "🫐 Seasonal Harvests",
  "🧀 Local Dairy & Cheese",
  "🌿 Handmade & Homegrown",
];

function MarqueeTicker() {
  const doubled = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div
      style={{
        background: "linear-gradient(90deg, #c6252d 0%, #a01e25 100%)",
        overflow: "hidden",
        padding: "15px 0",
        whiteSpace: "nowrap",
      }}
    >
      <div className="home-marquee">
        {doubled.map((item, i) => (
          <span key={i} className="home-marquee-item">
            {item}
            <span className="home-marquee-sep" aria-hidden="true">
              ✦
            </span>
          </span>
        ))}
      </div>
      <style>{`
        .home-marquee {
          display: inline-block;
          animation: home-marquee-scroll 42s linear infinite;
        }
        .home-marquee:hover {
          animation-play-state: paused;
        }
        .home-marquee-item {
          display: inline-flex;
          align-items: center;
          gap: 20px;
          color: #fff;
          font-weight: 700;
          font-size: 0.88rem;
          letter-spacing: 0.5px;
          font-family: 'Montserrat', 'Segoe UI', sans-serif;
          text-transform: uppercase;
        }
        .home-marquee-sep {
          color: rgba(255,255,255,0.35);
          font-size: 0.55rem;
          flex-shrink: 0;
        }
        @keyframes home-marquee-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}

export default function Home() {
  return (
    <div>
      <EventAlertPopup />
      <Hero />
      <MarqueeTicker />
      <WeeklySaturdayMarket />
      <FindUs />
      <Welcome />
      <UpcommingEvents />
      <AnimatedRentalSection />
      <Reviews />
    </div>
  );
}
